// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_nWa","cls2":"ImpactNavBar-cls2_drj ImpactNavBar-cls1_nWa"};